module.exports = __webpack_public_path__ + "static/media/studio-logo.b9843f62.svg";